import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  CreateLeadSubscriptionMutation,
  CreateLeadSubscriptionMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";
import { upsertCompanyLeadSubscription } from "./leadSubscriptionCache";

const createLeadSubscriptionMutation = graphql(`
  mutation createLeadSubscription($input: CreateLeadSubscriptionRequest!) {
    createLeadSubscription(CreateLeadSubscriptionRequest: $input) {
      id
      destinationSettings {
        type
        name
        webhookUrl
      }
      frequency
      disabled
      pausedByRefusals
      views {
        id
        name
        description
        dataType
        contentId
      }
    }
  }
`);

export function useCreateLeadSubscription(
  options?: UseMutationOptions<
    CreateLeadSubscriptionMutation,
    unknown,
    CreateLeadSubscriptionMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();
  const { data, ...rest } = useGraphQlMutation(createLeadSubscriptionMutation, {
    ...options,
    onSuccess: (data, variables, context) => {
      upsertCompanyLeadSubscription(queryClient, data.createLeadSubscription);
      options?.onSuccess && options?.onSuccess(data, variables, context);
    },
  });
  return { data: data?.createLeadSubscription, ...rest };
}
